import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-device-selection-dialog',
  templateUrl: './device-selection-dialog.component.html',
  styleUrls: ['./device-selection-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceSelectionDialogComponent {
  deviceForm: FormGroup;
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<DeviceSelectionDialogComponent>);
  private fb = inject(FormBuilder);

  constructor() {
    this.dialogRef.disableClose = false;
    this.deviceForm = this.fb.group({
      deviceType: ['', Validators.required],
    });
  }

  onContinue(): void {
    if (this.deviceForm.valid) {
      this.dialogRef.close(this.deviceForm.value.deviceType);
    }
  }
}
